import { getApiErrorMessage } from '../services/apiClient'

/**
 * Parse admin accept / modify-accept API errors (e.g. INSUFFICIENT_WAREHOUSE_STOCK).
 */
export function parseInsufficientStockAcceptError(err) {
  const data = err?.response?.data
  if (
    data?.code === 'INSUFFICIENT_WAREHOUSE_STOCK' &&
    Array.isArray(data.items) &&
    data.items.length > 0
  ) {
    return {
      message:
        typeof data.message === 'string'
          ? data.message
          : 'Cannot accept order: insufficient warehouse stock',
      items: data.items,
    }
  }
  return {
    message: getApiErrorMessage(err, 'Failed to perform action'),
    items: null,
  }
}
